import Vue from 'vue'
import axios from 'axios'

/*

Parameters example:

{
    filter: {
        ids: [10, 20, 30]
    },

    relations: ['details'],

    pagination: {
        itemsPerPage: 20,
        page: 1
    },

    orderBy: {
        column: 'name',
        direction: 'asc'
    },

    data: {
        name: 'John'
    },

    cancelToken: <token created with requester.cancelToken.create()>
}

*/

// API Base URL
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

// Number of retries on ConnectionFailure type errors (0 for no retries)
const maximumRetries = 2

// Retry delay in milliseconds
const retryDelay = 1000

const isResponseConnectionFailure = response => {
    return !!(
        response &&
        response.data &&
        response.data.status === 'error' &&
        response.data.message === 'ConnectionFailure'
    )
}

export default {
    cancelToken: {
        create () {
            return axios.CancelToken.source()
        },

        cancelAndCreate (cancelToken) {
            cancelToken.cancel()

            return this.create()
        },

        isCancel (exception) {
            return axios.isCancel(exception)
        }
    },

    async baseRequest (method, endpoint, parameters, config) {
        let token = 'Bearer ' + localStorage.getItem('token')

        if (token) {
            Vue.prototype.$http.defaults.headers.common['Authorization'] = token
        }

        let retries = 0

        let response = null

        while (response === null) {
            if (method === 'get') {
                response = await Vue.axios.get(endpoint, config)
            } else if (method === 'retrieve') {
                response = await Vue.axios.post(endpoint, parameters, config)
            } else if (method === 'create') {
                response = await Vue.axios.post(endpoint, parameters, config)
            } else if (method === 'update') {
                response = await Vue.axios.put(endpoint, parameters, config)
            } else if (method === 'delete') {
                response = await Vue.axios.put(endpoint, parameters, config)
            } else {
                response = await Vue.axios.post(endpoint, parameters, config)
            }

            if (
                isResponseConnectionFailure(response) &&
                retries < maximumRetries
            ) {
                response = null

                retries++

                await new Promise(resolve => setTimeout(resolve, retryDelay))
            }
        }

        if (isResponseConnectionFailure(response)) {
            throw new Error('ConnectionFailure')
        }

        return response
    },

    async get (endpoint, parameters) {
        return this.baseRequest('get', endpoint, parameters)
    },

    async create (endpoint, parameters) {
        return this.baseRequest('create', endpoint, parameters)
    },

    async retrieve (endpoint, parameters) {
        if (parameters && parameters.cancelToken) {
            return this.baseRequest('retrieve', endpoint, parameters, {
                cancelToken: parameters.cancelToken.token
            })
        } else {
            return this.baseRequest('retrieve', endpoint, parameters)
        }
    },

    async update (endpoint, parameters) {
        return this.baseRequest('update', endpoint, parameters)
    },

    async delete (endpoint, parameters) {
        return this.baseRequest('delete', endpoint, parameters)
    },

    async save (endpoint, parameters) {
        return this.baseRequest('save', endpoint, parameters)
    },

    API_BASE_URL
}
